import { useGetIdentity } from '@pankod/refine-core'
import React, { createContext, useState, FC, useContext, useEffect } from 'react'
import { ISearchCategories } from 'type'

import { nhost } from 'utility'
type UserContextState = {
  userRole: string
  changeUser: (name: string) => void
  userName: string
  changeUserName: (name: string) => void
  getAllUsersByRoles: (data: any[]) => void
  qcreatorList: any[]
  vcreatorList: any[]
  qreviewerList: any[]
  qapproverList: any[]
  evaluationInCharge: any[]
  evaluators: any[]
  paperApproverList: any[]
  paperSetterList: any[]
  subjectInChargeUsers: any[]
  productManagerList: any[]
  userLastSearch: any
  updateUserLastSearch: (key: string, value: string) => void
  resetUserContext: () => void 
}
const contextDefaultValues: UserContextState = {
  userRole: 'user',
  changeUser: () => {},
  userName: 'user',
  changeUserName: () => {},
  getAllUsersByRoles: () => {},
  qcreatorList: [],
  vcreatorList: [],
  qreviewerList: [],
  qapproverList: [],
  evaluationInCharge: [],
  evaluators: [],
  paperApproverList: [],
  paperSetterList: [],
  subjectInChargeUsers: [],
  productManagerList: [],
  userLastSearch: {},
  updateUserLastSearch: () => {},
  resetUserContext: () => {},
}

export const UserContext = createContext<UserContextState>(contextDefaultValues)

export const UserProvider: FC = ({ children }) => {
  console.log(contextDefaultValues.userRole, 'defult value')
  const [userRole, setUser] = useState<string>(contextDefaultValues.userRole)
  const [userName, setUserName] = useState<string>(contextDefaultValues.userName)
  const [qcreatorList, setCreatorList] = useState([] as any[])
  const [vcreatorList, setVariantCreatorList] = useState([] as any[])
  const [qreviewerList, setReviewerList] = useState([] as any[])
  const [qapproverList, setApproverList] = useState([] as any[])
  const [evaluationInCharge, setEvaluationInCharge] = useState([] as any[])
  const [paperApproverList, setPaperApproverList] = useState([] as any[])
  const [paperSetterList, setPaperSetterList] = useState([] as any[])
  const [evaluators, setEvaluators] = useState([] as any[])
  const [subjectInChargeUsers, setSubjectInChargeUsers] = useState([] as any[])
  const [productManagerList, setProductManagerList] = useState([] as any[])
  const [userLastSearch, setUserLastSearch] = useState<ISearchCategories>()

  const changeUser = (newUser: string) => setUser(newUser)
  const changeUserName = (newUser: string) => setUserName(newUser)
  const getAllUsersByRoles = (data: any[]) => {
    if (data?.length > 0) {
      const rolesMap = data.reduce(
        (acc: any, item: any) => {
          item.roles.forEach((role: any) => {
            if (role.role === 'qcreator') {
              acc.qcreatorList.push(item)
            } else if (role.role === 'qreviewer') {
              acc.qreviewerList.push(item)
            } else if (role.role === 'qapprover') {
              acc.qapproverList.push(item)
            } else if (role.role === 'variantcreator') {
              acc.vcreatorList.push(item)
            } else if (role.role === 'subjectincharge') {
              acc.subjectInChargeList.push(item)
            } else if (role.role === 'paperapprover') {
              acc.paperApproverList.push(item)
            } else if (role.role === 'papersetter') {
              acc.paperSetterList.push(item)
            } else if (role.role === 'evaluators') {
              acc.evaluatorList.push(item)
            } else if (role.role === 'evaluators') {
              acc.evaluatorList.push(item)
            } else if (role.role === 'evaluationincharge') {
              acc.evaluationInchargeList.push(item)
            } else if (role.role === 'productmanager') {
              acc.productManagerList.push(item)
            }
          })
          return acc
        },
        {
          qcreatorList: [],
          qreviewerList: [],
          qapproverList: [],
          vcreatorList: [],
          subjectInChargeList: [],
          paperApproverList: [],
          paperSetterList: [],
          evaluatorList: [],
          evaluationInchargeList: [],
          productManagerList: [],
        }
      )
      setCreatorList(rolesMap.qcreatorList)
      setReviewerList(rolesMap.qreviewerList)
      setApproverList(rolesMap.qapproverList)
      setVariantCreatorList(rolesMap.vcreatorList)
      setSubjectInChargeUsers(rolesMap.subjectInChargeList)
      setPaperApproverList(rolesMap.paperApproverList)
      setPaperSetterList(rolesMap.paperSetterList)
      setEvaluators(rolesMap.evaluatorList)
      setEvaluationInCharge(rolesMap.evaluationInchargeList)
      setProductManagerList(rolesMap?.productManagerList)
    }
  }
  //handing search -
  const updateUserLastSearch = (key: string, value: string) => {
    setUserLastSearch(prev => ({
      ...prev,
      [key]: value,
    }))
  }

  const resetUserContext = () => {
  setUser(contextDefaultValues.userRole)
  setUserName(contextDefaultValues.userName)
  setCreatorList([])
  setVariantCreatorList([])
  setReviewerList([])
  setApproverList([])
  setEvaluationInCharge([])
  setEvaluators([])
  setPaperApproverList([])
  setPaperSetterList([])
  setSubjectInChargeUsers([])
  setProductManagerList([])
  setUserLastSearch({})
}


  console.log('getAllUsersByRoles', qcreatorList)
  return (
    <UserContext.Provider
      value={{
        userRole,
        changeUser,
        userName,
        changeUserName,
        getAllUsersByRoles,
        qcreatorList,
        vcreatorList,
        qreviewerList,
        qapproverList,
        evaluationInCharge,
        evaluators,
        paperApproverList,
        paperSetterList,
        subjectInChargeUsers,
        productManagerList,
        userLastSearch,
        updateUserLastSearch,
        resetUserContext
      }}
    >
      {children}
    </UserContext.Provider>
  )
}

export const useUserContext = () => {
  const {
    userRole,
    changeUser,
    userName,
    changeUserName,
    qcreatorList,
    vcreatorList,
    qreviewerList,
    qapproverList,
    evaluationInCharge,
    evaluators,
    paperApproverList,
    paperSetterList,
    subjectInChargeUsers,
    getAllUsersByRoles,
    productManagerList,
    userLastSearch,
    updateUserLastSearch,
    resetUserContext
  } = useContext(UserContext)
  return {
    userRole,
    changeUser,
    userName,
    changeUserName,
    qcreatorList,
    vcreatorList,
    qreviewerList,
    qapproverList,
    evaluationInCharge,
    evaluators,
    paperApproverList,
    productManagerList,
    paperSetterList,
    subjectInChargeUsers,
    getAllUsersByRoles,
    userLastSearch,
    updateUserLastSearch,
    resetUserContext
  }
}
